import {register} from '../vendor/theme-scripts/theme-sections';
import {Ticker} from '../features/ticker';

const selectors = {
  frame: '[data-ticker-frame]',
  slideValue: 'data-slide',
  tickerScale: '[data-ticker-scale]',
  tickerText: '[data-ticker-text]',
};

const classes = {
  trickerAnimated: 'ticker--animated',
};

const sections = {};

class Bar {
  constructor(section) {
    this.container = section.container;

    this.init();
  }

  init() {
    this.initTickers(true);
  }

  /**
   * Init tickers in sliders
   */
  initTickers(stopClone = false) {
    const frame = this.container.querySelector(selectors.frame);

    if (frame) {
      new Ticker(frame, stopClone);
    }
  }

  toggleTicker(e, isStopped) {
    const tickerScale = this.container.querySelector(selectors.tickerScale);
    const element = this.container.querySelector(`[${selectors.slideValue}="${e.detail.blockId}"]`);

    if (!element || !tickerScale) return;

    if (isStopped) {
      const gutter = Number(getComputedStyle(element).getPropertyValue('--gutter').replace('px', ''));
      const leftPosition = -(element.offsetLeft - gutter);

      tickerScale.setAttribute('data-stop', '');
      tickerScale.querySelectorAll(selectors.tickerText).forEach((textHolder) => {
        textHolder.classList.remove(classes.trickerAnimated);
        textHolder.style.transform = `translate3d(${leftPosition}px, 0, 0)`;
      });
    }

    if (!isStopped) {
      tickerScale.querySelectorAll(selectors.tickerText).forEach((textHolder) => {
        textHolder.classList.add(classes.trickerAnimated);
        textHolder.removeAttribute('style');
      });
      tickerScale.removeAttribute('data-stop');
    }
  }

  onBlockSelect(e) {
    this.toggleTicker(e, true);
  }

  onBlockDeselect(e) {
    this.toggleTicker(e, false);
  }
}

const logos = {
  onLoad() {
    sections[this.id] = [];
    sections[this.id].push(new Bar(this));
  },
  onBlockSelect(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockSelect(e);
      }
    });
  },
  onBlockDeselect(e) {
    sections[this.id].forEach((el) => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockDeselect(e);
      }
    });
  },
};

register('logos', logos);
